import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { Selectable } from "@gamigo/gatsby-theme-strapi/src/sections/articles-with-widgets/articles-with-widgets-elements"

export const SectionWrapperStyles = css``
export const ContentWrapperStyles = css``
export const LeftColStyles = css``
export const RightColStyles = css``
export const HeadingWrapperStyles = css``
export const CategoriesStyles = css``
export const CategoryLinkStyles = css<Selectable>`
  color: ${props => (props.selected ? colors.white : colors.blue)};
  &:hover {
    color: ${colors.white};
  }
`

export const ArticlesStyles = css`
  border: 1px solid ${colors.blue};
  background-color: ${colors.darker};
`
